import React from "react";
import CookieConsentManager from "./useCookieConsent";
import styles from "./ConsentGate.module.css";
import { IS_COOKIE_BOT_ENABLED } from "../constant/Constants";


const ConsentCard = ({ children }) => (
    <main className={styles.page}>
        <header className={styles.portalHeader}>
            <h1 className={`fw-bolder truncate text-center fw-medium ${styles.search_font} `}>
                Non-Profit Patient Partner Portal
            </h1>
            {/* <p className={styles.portalDescription}>
                Manage All Your Applications, Claims, &amp; Cases in One Place
            </p> */}
        </header>
        <section className={styles.card} aria-labelledby="cookie-consent-title">
            {children}
        </section>
    </main>
);

const ConsentGate = ({ children }) => {
    const renderContent = (consentGiven) => {
        if (!IS_COOKIE_BOT_ENABLED || consentGiven === true) {
            return children;
        }

        if (consentGiven === false) {
            return (
                <ConsentCard>
                    <h2 id="cookie-consent-title" className={styles.title}>
                        Access Restricted
                    </h2>
                    <p className={styles.message}>
                        You have declined cookie consent. This website requires
                        cookies to function properly.
                    </p>
                    <button
                        className={styles.reviewButton}
                        type="button"
                        onClick={() => window.Cookiebot?.renew()}
                    >
                        Review Cookie Settings
                    </button>
                </ConsentCard>
            );
        }

        return (
            <ConsentCard>
                <h2 id="cookie-consent-title" className={styles.title}>
                    Cookie Consent Required
                </h2>
                <p className={styles.message}>
                    Please respond to the cookie consent banner to continue.
                </p>
            </ConsentCard>
        );
    };

    return <CookieConsentManager>{renderContent}</CookieConsentManager>;
};

export default ConsentGate;
